// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithTagName } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

function Tab(index, element) {
    this.determineState = function () {
        this.selected = new HtmlClassSwitch(this.element, "Selected").getStatus();
        this.add = new HtmlClassSwitch(this.element, "Add").getStatus();
    }

    this.index = index;
    this.element = element;
    this.selected = false;
    this.add = false;

    this.determineState();
}

export class TabMenu extends WebPageComponent {
  constructor(element) {
    super(element);

    this.tabs = new Array();
    this.expanded = new HtmlClassSwitch(this.element, "Expanded");
    this.hasAdd = false;
    this.determineTabs();
    this.addComponents();
  }

  determineTabs() {
    const query = new DomQuery(this.element);

    const tabElements = query.getChildren(WithTagName("LI"));

    for (let index = 0; index < tabElements.length; index++) {
      const tab = new Tab(index, tabElements[index]);
      this.tabs.push(tab);

      if (tab.add)
        this.hasAdd = true;
    }
  }

  addComponents() {
    if (this.hasAdd) {
      const expand = document.createElement("li");

      expand.classList.add("Expand");
      expand.onclick = (event) => {
        this.toggleAdd();
      };

      this.element.appendChild(expand, this.element);
    }
  }

  toggleAdd() {
    this.expanded.toggle();
  }
}

interactivityRegistration.register("TabMenu", function (element) { return new TabMenu(element); });
